import type { Answers, Gate, GateCondition } from './types';

// Mirrors backend/src/services/SurveyService.js evalGate/evalCondition
// exactly (same op set, same and/or compound shape) so a question shows or
// hides in the runner the instant its dependency is answered, with no
// round-trip — and so the client-side gate the student sees always agrees
// with the server-side gate that validates the submission.

function evalCondition(cond: GateCondition | undefined, answers: Answers): boolean {
  if (!cond || !cond.question_id) return false;
  const v = answers[cond.question_id];
  switch (cond.op) {
    case 'gte': return typeof v === 'number' && v >= (cond.value as number);
    case 'lte': return typeof v === 'number' && v <= (cond.value as number);
    case 'eq': return v === cond.value;
    case 'ne': return v !== cond.value;
    case 'in': return Array.isArray(cond.value) && (cond.value as unknown[]).includes(v);
    default: return false;
  }
}

export function evalGate(gate: Gate | undefined, answers: Answers): boolean {
  if (!gate) return true;
  if (gate.op === 'and') return (gate.conditions ?? []).every((c) => evalCondition(c, answers));
  if (gate.op === 'or') return (gate.conditions ?? []).some((c) => evalCondition(c, answers));
  return evalCondition(gate as GateCondition, answers);
}
